module.exports = __webpack_public_path__ + "img/rocket-flame.9c854502.svg";